import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-general-warning-modal',
    templateUrl: './general-warning-modal.component.html',
    styleUrls: ['./general-warning-modal.component.scss'],
    imports: [MatDialogTitle, MatDialogClose, CdkScrollable, MatDialogContent, MatDialogActions, NgClass]
})
export class GeneralWarningModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GeneralWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string | "Are you sure?",
      message: string | "message",
      question: string | "Do you wish to continue?",
      cancelText: string | "Cancel",
      confirmText: string | "Confirm",
      isPlainMessage: boolean | true
    }
  ) {}

  ngOnInit() {
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  confirm() {
    this.dialogRef.close(true);
  }

}
